// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__JQ6u0","title":"Info_title__5sQ23","selects":"Info_selects__1IrDR","requiredAsterisk":"Info_requiredAsterisk__1c3Hs"};